const html =
    `<div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>`

const box = document.createElement('div')
box.className = 'spinner-box'
box.innerHTML = html

export const show = () => document.body.appendChild(box)
export const hide = () => box.remove()




// WEBPACK FOOTER //
// ./Statics/scripts/common/spinner.js